import { ENV } from "@/constants/env";

/** True for local Vite dev or deployed environments that point at the "dev" stack. */
export function isDevEnvironment(): boolean {
    if (ENV.DEV) {
        return true;
    }

    return ENV.APP_URL.includes("dev") || ENV.AUTH_SVC_URL.includes("dev");
}
